import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import PlayCircleSVG from '../../../../assets/PlayCircleSVG';
import AppButton from '../../../../CommonComponents/UI/AppButton/AppButton';
import { LOADING } from '../../../../Constants/commonConstants';
import { useTakeTour } from '../../hooks/useTakeTour';

const TakeTourButton = ({ ...props }) => {
  const { startDocChatDashboardTour, startViewerDocChatTour } = useTakeTour();
  const uploadStatus = useSelector((state) => state.docChatData.uploadStatus);
  const { pathname } = useLocation();
  const takeTourButtonVisible = pathname === '/docchat' || pathname.startsWith('/viewer-docchat');
  const takeTourButtonClickHandler = () => {
    if (pathname === '/docchat') {
      startDocChatDashboardTour(true);
    } else if (pathname.startsWith('/viewer-docchat')) {
      startViewerDocChatTour(true);
    }
  };

  return (
    takeTourButtonVisible && (
      <AppButton
        color='primary'
        variant='outlined'
        shape='round'
        $height='36px'
        $gap='5px'
        onClick={takeTourButtonClickHandler}
        icon={<PlayCircleSVG />}
        disabled={uploadStatus === LOADING}
        {...props}
      >
        Take Tour
      </AppButton>
    )
  );
};

export default TakeTourButton;
